/**
 * Created by Ning Jiang on 11/22/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {BS2GameAssets} from "./BS2GameAssets";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {BS2Statics} from "./config/BS2Statics";
import {BS2Model} from "./server/BS2Model";
import {RestoreUtils} from "./utils/RestoreUtils";
import {GraphicsPool} from "./utils/GraphicsPool";
import {BS2Sound} from "./config/sound/BS2Sound";
import {BS2ReelsView} from "./reels/BS2ReelsView";
import {BS2WinView} from "./view/BS2WinView";
import {BS2TransitionScreenView} from "./view/BS2TransitionScreenView";
import {BS2WinPresentation} from "./gameflow/BS2WinPresentation";
import {BS2NormalBetPresentation} from "./gameflow/BS2NormalBetPresentation";
import {BS2IdleNormalPresentation} from "./gameflow/BS2IdleNormalPresentation";
import {BS2BackgroundElements} from "./view/BS2BackgroundElements";
import {BS2GameMode} from "./server/BS2GameMode";
import {BS2AvalancheResult} from "./gameflow/BS2AvalancheResult";
import {BS2ZeroBetPresentation} from "./gameflow/BS2ZeroBetPresentation";
import {BS2SuperFreeSpinIdlePresentation} from "./gameflow/BS2SuperFreeSpinIdlePresentation";
import {BS2NormalResultPresentation} from "./gameflow/BS2NormalResultPresentation";
import {
    BonusFeatureDisplayConfigurationList
} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {BonusBuyPopUpContent} from "@nolimitcity/promo-panel/bin/feature/generic/BonusBuyPopUpContent";
import {Label} from "@nolimitcity/slot-launcher/bin/gui/labels/Label";
import {Skinner} from "@nolimitcity/slot-launcher/bin/utils/Skinner";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";


export class BS2 extends SlotGame {
    public static model: BS2Model;
    public static assetLoader: AssetLoader;
    public static soundPlayer: BS2Sound;
    public static backgroundElements: BS2BackgroundElements;
    public static gameFlowController: GameFlowController;

    public static reelView: BS2ReelsView;
    public static graphicsPool: GraphicsPool;
    public static winView: BS2WinView;
    public static transitionScreen: BS2TransitionScreenView;
    public static normalBet: BS2NormalBetPresentation;
    public static NO_WIN_DATA_BOOSTED_BET_2: any = {
        "reels": [
            [
                "H1",
                "H2",
                "H1",
                "H2",
                "H1",
                "H2",
                "H1"
            ],
            [
                "H5",
                "H4",
                "H5",
                "H4",
                "H5",
                "H4",
                "H5"
            ],
            [
                "H3",
                "H2",
                "H3",
                "H2",
                "H2",
                "H3",
                "H2"
            ],
            [
                "H5",
                "H5",
                "H5",
                "H5",
                "H5",
                "H5",
                "H5"
            ],
            [
                "H1",
                "H5",
                "H1",
                "H5",
                "H5",
                "H5",
                "H5"
            ]
        ],
        "evaluatedArea": [
            [
                "H2",
                "H1",
                "H2",
                "H1",
                "H2"
            ],
            [
                "H4",
                "H5",
                "H4",
                "H5",
                "H4",
            ],
            [
                "H2",
                "H3",
                "H2",
                "H2",
                "H3"
            ],
            [
                "H5",
                "H5",
                "H5",
                "H5",
                "H5",
            ],
            [
                "H5",
                "H1",
                "H5",
                "H5",
                "H5",
            ]
        ],
        "reelsAfterCollapse": [
            [
                "H2",
                "H1",
                "H2",
                "H1",
                "H2"
            ],
            [
                "H4",
                "H5",
                "H4",
                "H5",
                "H4",
            ],
            [
                "H2",
                "H3",
                "H2",
                "H2",
                "H3"
            ],
            [
                "H5",
                "H5",
                "H5",
                "H5",
                "H5",
            ],
            [
                "H5",
                "H1",
                "H5",
                "H5",
                "H5",
            ]
        ],
        "betWayWins": [],
        "totalSpinWinnings": 0,
        "accumulatedRoundWin": 0,
        "thisSpinWinning": 0,
        "playedBetValue": 1,
        "mode": "NORMAL",
        "nextMode": "NORMAL",
        "numberOfFreespinsPlayed": 0,
        "freespinsLeft": 0,
        "addedNumberOfFreespinsThisSpin": 0,
        "symbolSizes": [
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "symbolSizesAfterCollapse": [
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "wasFeatureBuy": false,
        "brokeTheBank": false,
        "nextLevel": 0,
        "currentLevel": 0,
        "collectedSymbols": 0,
        "upgradeLevel": false,
        "enhancedBet": false,
        "totalCollectedSymbols": 0,
        "prevRespSymbolSizesAfterCollapse": [
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "splitDirections": [
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ]
        ],
        "splitDirectionsAfterCollapse": [
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ]
        ]
    }
    public static NO_WIN_DATA: any = {
        "reels": [
            [
                "M1",
                "M1",
                "L3",
                "L5",
                "L3",
                "L1",
                "M1"
            ],
            [
                "L2",
                "M2",
                "M3",
                "L3",
                "L2",
                "M5",
                "L2"
            ],
            [
                "M1",
                "L5",
                "M5",
                "L2",
                "L5",
                "L4",
                "L5"
            ],
            [
                "L1",
                "L4",
                "M5",
                "L5",
                "M3",
                "M1",
                "L1"
            ],
            [
                "M4",
                "L5",
                "L1",
                "L5",
                "L3",
                "M3",
                "L1"
            ]
        ],
        "evaluatedArea": [
            [
                "M1",
                "L3",
                "L5",
                "L3",
                "L1"
            ],
            [
                "M2",
                "M3",
                "L3",
                "L2",
                "M5",
            ],
            [
                "L5",
                "M5",
                "L2",
                "L5",
                "L4"
            ],
            [
                "L4",
                "M5",
                "L5",
                "M3",
                "M1"
            ],
            [
                "L5",
                "L1",
                "L5",
                "L3",
                "M3"
            ]
        ],
        "reelsAfterCollapse": [
            [
                "M1",
                "L3",
                "L5",
                "L3",
                "L1"
            ],
            [
                "M2",
                "M3",
                "L3",
                "L2",
                "M5"
            ],
            [
                "L5",
                "M5",
                "L2",
                "L5",
                "L4"
            ],
            [
                "L4",
                "M5",
                "L5",
                "M3",
                "M1"
            ],
            [
                "L5",
                "L1",
                "L5",
                "L3",
                "M3"
            ]
        ],
        "betWayWins": [],
        "totalSpinWinnings": 0,
        "accumulatedRoundWin": 0,
        "thisSpinWinning": 0,
        "playedBetValue": 1,
        "mode": "NORMAL",
        "nextMode": "NORMAL",
        "numberOfFreespinsPlayed": 0,
        "freespinsLeft": 0,
        "addedNumberOfFreespinsThisSpin": 0,
        "symbolSizes": [
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "symbolSizesAfterCollapse": [
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "wasFeatureBuy": false,
        "brokeTheBank": false,
        "nextLevel": 0,
        "currentLevel": 0,
        "collectedSymbols": 0,
        "upgradeLevel": false,
        "enhancedBet": false,
        "totalCollectedSymbols": 0,
        "prevRespSymbolSizesAfterCollapse": [
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ],
            [
                1,
                1,
                1,
                1,
                1
            ]
        ],
        "splitDirections": [
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ]
        ],
        "splitDirectionsAfterCollapse": [
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1,
                -1,
                -1
            ]
        ]
    }
    private static skinner:Skinner;
    constructor() {
        super();
        const validSkins:string[] = [
            "sweep",
            "us-nonfree"
        ]
        BS2.skinner = new Skinner(validSkins);
    }


    private handleSkinInit(){
        //Making sure that skinID is set based  on "replaceWordFree" gcc.
        if (SlotGame.apiPlugin.gameClientConfiguration.isSet) {
            if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                BS2.skinner.skinId = "sweep";
            }
            if (SlotGame.apiPlugin.gameClientConfiguration.replaceWordFree) {
                BS2.skinner.skinId = "us-nonfree";
            }
        } else {
            SlotGame.apiPlugin.events.on(APIEvent.GAME_CLIENT_CONFIGURATION_APPLIED, () => {
                if (SlotGame.apiPlugin.gameClientConfiguration.sweepGfx) {
                    BS2.skinner.skinId = "sweep";
                }
                if (SlotGame.apiPlugin.gameClientConfiguration.replaceWordFree) {
                    BS2.skinner.skinId = "us-nonfree";
                }
            })
        }
    }

    private handleSkinGetReady() : Promise<any>{
        if (BS2.skinner.skinId != undefined) {
            const replaceMap:Map<string, string> = new Map();
            if(BS2.skinner.skinId==="us-nonfree"){
                replaceMap.set("feature3", "intro_feature3.png");
                replaceMap.set("pageImage_7", "pageImage_7.png");
            }else {
                //Bonus
                replaceMap.set("intro_feature4", "intro_feature4.png")
                replaceMap.set("BOOSTED_BET_1", "BOOSTED_BET_1.png");
            }
            return BS2.skinner.loadSkin(replaceMap);
        }
        return Promise.resolve();
    }


    public static getBetPrice(): number {
        let price: string = BS2.apiPlugin.freeBets.hasFreeBets() ? BS2.apiPlugin.freeBets.getBet() : BS2.apiPlugin.betLevel.getLevel();
        // const activeBetFeature: BetFeature | undefined = BS2.apiPlugin.betFeatureController.getActiveBetFeature()
        // if (activeBetFeature) {
        //     price = BS2.apiPlugin.currency.formatValue(activeBetFeature.getTotalCost());
        // }
        if (BS2.model.buyFeatureName) {
            for (let index: number = 0; index < BS2.model.initData.featureBuyTimesBetValue.length; index++) {
                if (BS2.model.initData.featureBuyTimesBetValue[index].name === BS2.model.buyFeatureName) {
                    let numberCost: number = parseFloat(price)
                    numberCost *= BS2.model.initData.featureBuyTimesBetValue[index].price;
                    price = numberCost.toString();
                }
            }
        }

        return parseFloat(price);
    }

    public static isWinBelowStake(): boolean {
        return BS2.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (BS2.model.data.accumulatedRoundWin <= this.getBetPrice());
    }

    public static isWinBelowStakeNoRestriction(): boolean {
        return (BS2.model.data.accumulatedRoundWin <= this.getBetPrice());
    }

    public static isWinBelowStakeSpinWinnings(): boolean {
        let playedBetValue: number = BS2.model.gameData?.playedBetValue || parseFloat(BS2.apiPlugin.freeBets.hasFreeBets() ? BS2.apiPlugin.freeBets.getBet() : BS2.apiPlugin.betLevel.getLevel());

        return BS2.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (BS2.model.gameData.thisSpinWinning / playedBetValue <= 1);
    }

    public getNoWinGameData(): any {
        return (BS2.normalBet.apiEventData && BS2.normalBet.apiEventData?.playerInteraction?.featureName === BS2Statics.BOOSTED_BET_2) ? BS2.NO_WIN_DATA_BOOSTED_BET_2 : BS2.NO_WIN_DATA;
    }

    public getSymbolString(key: string, data: { 3: number, 4: number, 5: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    public getSymbolStringWild(key: string, data: { 3: number, 4: number, 5: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
            </div>
            </div>
        `;
    }

    private paytable:string = require("../../nolimit/screens/paytable.mustache");
    public getPaytable(): Promise<string> {
        return new Promise((resolve, reject) => {
            const data=Object.assign(BS2.apiPlugin.gameClientConfiguration);
            data.skinPath="bonus/";

            if (BS2.skinner.skinId != undefined) {
                data.skinPath = `../resources/images/${BS2.skinner.skinId}/`;
            }
            let symbolDataValueData = BS2Statics.defaultSymbolValues;
            if (BS2.model?.symbolValues) {
                symbolDataValueData = BS2.model?.symbolValues;
                Logger.logDev("Using symbolValues from INIT data");
            } else {
                Logger.logDev("Using default symbolValues ");
            }

            let paytableString: string = (<any>this.paytable).text;
            for (let key in symbolDataValueData) {
                if (key === "W") {
                    paytableString = paytableString.replace(`{{${key}}}`, this.getSymbolStringWild(key, symbolDataValueData[key]))
                } else {
                    paytableString = paytableString.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
                }
            }
            paytableString = paytableString.replace(/{{skinPath}}/g, data.skinPath);
            paytableString=BS2.apiPlugin.translations.render(paytableString,data);
            resolve(paytableString);
        });
    }

    public getNolimitBonusDisplayConfiguration(): BonusFeatureDisplayConfigurationList {
        return {
            SUPER_FREESPIN: {
                displayName: "SUPER_FREESPIN",
                displayOrder: 1,
            },

            FREESPIN: {
                displayName: "FREESPIN",
                displayOrder: 0,
            },
            LUCKY_DRAW: {
                displayName: "LUCKY_DRAW",
                displayOrder: 2,
            },

            BOOSTED_BET_1: {
                displayName: "BOOSTED_BET_1",
                displayOrder: 3,
                replacePopUpContent: (content: BonusBuyPopUpContent) => {
                    const warningTextText: string = "3 times more likely to hit Reign of Terror Spins.";
                    const warningText = new Label(BS2.apiPlugin.translations.translate(warningTextText),
                        content.textLabel.getStyleClone());
                    warningText.scale.set(0.75, 0.75);
                    warningText.anchor.set(0.5, 0.5);
                    warningText.position.set(0, 375);
                    content.addChild(warningText);

                    content.textLabel.scale.set(0.75, 0.75);
                    content.textLabel.position.y -= 30;

                    return content;
                }
            },
            BOOSTED_BET_2: {
                displayName: "BOOSTED_BET_2",
                displayOrder: 4,
            },
        }
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            BS2.model = new BS2Model(SlotGame.apiPlugin, true);
            BS2.gameFlowController = new GameFlowController(SlotGame.apiPlugin, BS2.model);
            BS2.gameFlowController.flowStateLogger.level = LogLevel.DEV;

            const winPres: BS2WinPresentation = new BS2WinPresentation();
            const normalResult: BS2NormalResultPresentation = new BS2NormalResultPresentation();


            const zeroBetIdle: BS2ZeroBetPresentation = new BS2ZeroBetPresentation();
            const avalancheResult: BS2AvalancheResult = new BS2AvalancheResult();
            BS2.normalBet = new BS2NormalBetPresentation();


            BS2.gameFlowController.addGameModeFlowStatePresentationMap(BS2GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new BS2IdleNormalPresentation()],
                [FlowState.BET, BS2.normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));


            BS2.gameFlowController.addGameModeFlowStatePresentationMap(BS2GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.BET, BS2.normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));

            BS2.gameFlowController.addGameModeFlowStatePresentationMap(BS2GameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, new BS2SuperFreeSpinIdlePresentation()],
                [FlowState.BET, BS2.normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));


            //AVALANCHE MODES
            BS2.gameFlowController.addGameModeFlowStatePresentationMap(BS2GameMode.AVALANCHE_NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            BS2.gameFlowController.addGameModeFlowStatePresentationMap(BS2GameMode.AVALANCHE_FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));

            BS2.gameFlowController.addGameModeFlowStatePresentationMap(BS2GameMode.AVALANCHE_FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, zeroBetIdle],
                [FlowState.RESULT, avalancheResult],
                [FlowState.WIN, winPres]
            ]));


            // if (NolimitConfig.isDevMode){
            //     (<any>globalThis).__PIXI_APP__ = NolimitApplication.pixiApp;
            // }
            this.handleSkinInit();

            return value;
        });
    }

    public getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        return super.getReady().then((value: NolimitPlugin) => {

            const fontLoader = new FontLoader(NolimitApplication.resourcePath);
            fontLoader.add(OpenSans.ITALIC_600);
            fontLoader.add(OpenSans.NORMAL_300);
            fontLoader.add(OpenSans.NORMAL_400);
            fontLoader.add(OpenSans.NORMAL_700);

            AssetsConfig.addToAssetsConfig(BS2GameAssets.RESOURCES_GROUPS);
            BS2.assetLoader = new AssetLoader(BS2.apiPlugin, NolimitApplication.resourcePath + "/resources/");

            const promises = Promise.all([fontLoader.load(), BS2.assetLoader.load(ResourcesGroupName.MAIN)]);

            return promises.then(async (values: any) => {
                await this.handleSkinGetReady();

                this.createViewsAndComponents();

                RestoreUtils.startupGame(BS2.model.initData.isRestoreState);
                // SpineViewUtils.init(BS2GameAssets.RESOURCES_GROUPS.main, BS2.assetLoader, [BS2GameAssets.W_SPINE, BS2GameAssets.SIGILL_LVL_1, BS2GameAssets.M1_SPINE, BS2GameAssets.L1_SPINE,BS2GameAssets.S_SPINE]);
                return value;
            });
        });
    }

    public getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, waiting for user to start game.
        return super.getReadyToStart().then((value: NolimitPlugin) => {
            BS2.soundPlayer.switchMusic(BS2Sound.MAIN_GAME_MUSIC);
            return value;
        });
    }

    public start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        return super.start().then((value: NolimitPlugin) => {
            BS2.reelView.onResize()
            BS2.gameFlowController.start();
            if (BS2.model.isRestore && BS2.model.buyFeatureName === BS2Statics.BOOSTED_BET_2) {
                BS2.soundPlayer.fadeOutMusic(100,0);
                BS2.soundPlayer.playLoopMusic(BS2Sound.XBET2_LOOP);
                BS2.soundPlayer.fadeInLoopMusic(BS2Sound.XBET2_LOOP, 0.7);
            } else {
                BS2.soundPlayer.switchMusic(BS2.model.data.mode);
            }
            BS2.soundPlayer.startLevel(BS2.model.data.currentLevel);
            return value;
        });
    }

    private createViewsAndComponents() {
        //Non views
        BS2.graphicsPool = new GraphicsPool();
        BS2.soundPlayer = new BS2Sound();

        //Static views
        BS2.backgroundElements = new BS2BackgroundElements();
        BS2.winView = new BS2WinView();
        BS2.reelView = new BS2ReelsView();
        //BS2.foregroundElements = new BS2ForegroundElements();
        BS2.transitionScreen = new BS2TransitionScreenView();

        NolimitApplication.addLayerAt(BS2.transitionScreen.name, BS2.transitionScreen, 0);
        NolimitApplication.addLayerAt(BS2.winView.name, BS2.winView, 0);
        NolimitApplication.addLayerAt(BS2.reelView.name, BS2.reelView, 0);
        NolimitApplication.addLayerAt(BS2.backgroundElements.name, BS2.backgroundElements, 0);
    }

    public static getSkinName():string|undefined{
        return BS2.skinner.skinId;
    }


}